import { Deserializer } from "jsonapi-serializer";
import { genericError } from "../models/GenericError";
import { ListQuery } from '../models/ListQuery';
import { TourRoute, TourRouteWrapper } from "../models/TourRoute";
import { APIConnector } from './api/APIConnector';
import { createPagination } from "./utilities/paginationBuilder";
import { processServerError, getConstraintViolation } from "./utilities/ServiceError";
import { createPartialURL, getFilterClause } from "./utilities/urlBuilder";
const apiConnector = new APIConnector();

export const getTourRoutes = async (listParameters?: ListQuery): Promise<TourRouteWrapper> => {
    try {
        const filter: string = getFilterClause(listParameters?.filters, listParameters?.searchTerm)
        const partialURL = createPartialURL(listParameters?.goToPage, listParameters?.pageSize, listParameters?.sortBy, filter);
        const url = `tour?include=area.site${partialURL}`;

        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const pagination = createPagination(json.meta);

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({status: response.status, message: getConstraintViolation(json.errors[0].detail), success: false })
            }
            new Deserializer().deserialize(json, (error: any, data: any[]) => {
                if (error) {
                    return reject({status: response.status, message: genericError });
                }
                const rows: TourRoute[] = data.map((tourRoute): TourRoute => {
                    return {
                        id: tourRoute['id'],
                        name: tourRoute['tour-name'],
                        site: tourRoute['area']['site']['site-name'],
                    }
                })

                return resolve({ rows, pagination });
            })
        });
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}
